import { supabase } from "@/integrations/supabase/client";

export type MediaBucket = "avatars" | "voice-intros" | "video-intros";

const extFromMime = (mime: string, fallback: string) => {
  const map: Record<string, string> = {
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/webp": "webp",
    "image/heic": "heic",
    "audio/webm": "webm",
    "audio/mp4": "m4a",
    "audio/mpeg": "mp3",
    "audio/ogg": "ogg",
    "video/webm": "webm",
    "video/mp4": "mp4",
  };
  return map[mime] ?? fallback;
};

/** Upload a Blob/File to a bucket under {userId}/{prefix}-{timestamp}.{ext}. Returns public URL. */
export const uploadMedia = async (
  bucket: MediaBucket,
  userId: string,
  blob: Blob,
  prefix: string,
  fallbackExt = "bin",
): Promise<string> => {
  const ext = extFromMime(blob.type, fallbackExt);
  const path = `${userId}/${prefix}-${Date.now()}.${ext}`;
  const { error } = await supabase.storage
    .from(bucket)
    .upload(path, blob, { upsert: false, contentType: blob.type || undefined });
  if (error) throw error;
  const { data } = supabase.storage.from(bucket).getPublicUrl(path);
  return data.publicUrl;
};

/** Delete a previously-uploaded public URL. Best-effort, ignores errors. */
export const deleteMedia = async (bucket: MediaBucket, publicUrl: string) => {
  const marker = `/storage/v1/object/public/${bucket}/`;
  const idx = publicUrl.indexOf(marker);
  if (idx === -1) return;
  const path = publicUrl.slice(idx + marker.length);
  await supabase.storage.from(bucket).remove([path]);
};
